import defaultAxios from "axios";

export const axios = defaultAxios.create({
  baseURL: "https://team6project.onrender.com/api",
});
